const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// document.addEventListener('DOMContentLoaded', function() {
//   // Find all elements with a class containing 'bundle-products-template'
//   const parentElements = document.querySelectorAll('[class*="bundle-products-template"]');

//   // Iterate over each parent element
//   parentElements.forEach(function(parent) {
//     // Find child elements within the parent that match the starting class 'bundle-product-title-template'
//     const childElements = parent.querySelectorAll('[class^="bundle-product-title-template"]');

//     // Add custom HTML to each matching child element
//     childElements.forEach(function(child) {
//       const customHTML = document.createElement('div');
//       customHTML.innerHTML = '<p class="custom-html">Flavor Details</p>';

//       // Insert the custom HTML after the matched child element
//       child.parentNode.insertBefore(customHTML, child.nextSibling);
//     });
//   });
// });
